import { TemplateName } from 'src/api/learningSessions/types';
import { DefaultTheme } from 'styled-components';
import { TestCardData } from '../utils';

export const getLargeScreenLayout = (
  prompt: TestCardData['prompt'],
  response: TestCardData['response'],
): 'grid' | 'column' => {
  if (
    response.templateName === TemplateName.MULTIPLE_CHOICE ||
    response.templateName === TemplateName.REVERSED_MULTIPLE_CHOICE
  ) {
    if (prompt.promptType === 'Text' && response.responseType === 'Text') return 'grid';

    if (response.responseType === 'Image') return 'grid';
  }

  return 'column';
};

export const getFontSize = (showBigger: boolean, theme: DefaultTheme): string =>
  showBigger ? theme.DEPRECATED_ty.largest : theme.DEPRECATED_ty.larger;
